import { DocumentType } from "@biblioteksentralen/cordata";
import { Box, StackProps, Text } from "@biblioteksentralen/react";
import { capitalize } from "radash";
import { TranslateMicroText, useTranslation } from "../../../utils/hooks/useTranslation";
import { getDocumentTypeDefiniteNoun } from "../../cordata/documentTypes";
import { ReservationContainer, reservationFullWidthBreakpoint } from "./ReservationContainer";

type ReservationWithNoHoldingsProps = {
  getText: (t: TranslateMicroText, documentTypeName: string) => string;
  currentDocumentType: DocumentType | undefined;
} & StackProps;

export const ReservationTextContainer = ({
  getText,
  currentDocumentType,
  ...stackProps
}: ReservationWithNoHoldingsProps) => {
  const { t, ts } = useTranslation();
  const documentTypeName = capitalize(
    ts(getDocumentTypeDefiniteNoun(currentDocumentType, { withDeterminative: true })) ?? ""
  );

  return (
    <ReservationContainer
      documentType={currentDocumentType}
      minHeight={{ base: "10rem", [reservationFullWidthBreakpoint]: "20rem" }}
      {...stackProps}
    >
      <Box>
        <br />
        <Text>{getText(t, documentTypeName)}</Text>
      </Box>
    </ReservationContainer>
  );
};
